<section class="main-section">
    <div class="d-flex justify-content-center main-title-wrapper">
        <ng-container *ngIf="contact.used === 'email'">
            <p
                class="main-title"
                [innerHtml]="'pt.edp.edponline.token.validation.email.message' | translate: { CONTACT_EMAIL: contact.contact.email }"
            ></p>
        </ng-container>
        <ng-container *ngIf="contact.used === 'mobile'">
            <p
                class="main-title"
                [innerHtml]="'pt.edp.edponline.token.validation.mobile.message' | translate: { CONTACT_MOBILE: contact.contact.mobile }"
            ></p>
        </ng-container>
    </div>
    <edp-token-input (onSubmit)="setToken($event)" [isError]="isError"></edp-token-input>
    <ng-container *ngIf="isError">
        <div class="d-flex justify-content-center main-error-message-wrapper">
            <p class="main-error-message">{{ "pt.edp.edponline.token.validation.token.error.message" | translate }}</p>
        </div>
    </ng-container>
    <div class="d-flex justify-content-center main-resend-text-wrapper">
        <p class="main-resend-text">
            {{ "pt.edp.edponline.token.validation.token.did.not.receive" | translate }}?
            <span (click)="resendToken()" class="main-resend-text-link">
                {{ "pt.edp.edponline.token.validation.token.resend" | translate }}
            </span>
        </p>
    </div>
    <div class="recaptcha-wrapper">
        <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"></re-captcha>
    </div>
</section>
